import type { ProviderKind } from '@pipi/shared';
import { Cloud, Disc3, FileMusic, Library, Radio, Sparkles } from 'lucide-react';

const config: Record<ProviderKind, { label: string; Icon: typeof Cloud }> = {
  demo: { label: '皮皮练唱', Icon: Sparkles },
  local: { label: '本地', Icon: FileMusic },
  jellyfin: { label: 'Jellyfin', Icon: Library },
  plex: { label: 'Plex', Icon: Disc3 },
  mugen: { label: 'Mugen', Icon: Radio },
  allkaraoke: { label: 'AllK', Icon: Cloud },
};

export function ProviderBadge({ kind, compact = false }: { kind: ProviderKind; compact?: boolean }) {
  const { label, Icon } = config[kind];
  return (
    <span className={`provider-badge provider-badge--${kind}`} title={label}>
      <Icon size={compact ? 14 : 16} strokeWidth={2.2} />
      {!compact && <span>{label}</span>}
    </span>
  );
}
